import { useEffect, type CSSProperties } from "react";
import { Outlet, useSearchParams } from "react-router-dom";

import { LocaleProvider, resolveLocale } from "@/apps/@components";

import { wallpaperMessages } from "../message";
import {
	WALLPAPER_COUNTRY_KEY,
	WALLPAPER_LANG_KEY,
	persistParam,
	resolveParam,
} from "../wallpaperParams";
import { WallpaperFlowProvider } from "./WallpaperFlowContext";

/**
 * 桌布活動的最外層：只提供語系與流程 context，不含任何版面。
 * 讓 /wallpaper 底下所有頁（含版面不同的 home）都能用 useLocale / useWallpaperFlow。
 *
 * 國際版的 lang / country 會存進 sessionStorage：URL 有帶就寫入、沿用；
 * 沒帶（例如切頁時 search 掉了、或 reload）就沿用既有值，關閉分頁自動清除。
 */
export default function WallpaperProviders() {
	const [searchParams] = useSearchParams();
	const langParam = searchParams.get("lang");
	const countryParam = searchParams.get("country");

	// URL 有帶參數就寫入 sessionStorage
	useEffect(() => {
		persistParam(WALLPAPER_LANG_KEY, langParam);
		persistParam(WALLPAPER_COUNTRY_KEY, countryParam);
	}, [langParam, countryParam]);

	// 有效值：URL 優先，否則沿用 sessionStorage
	const lang = resolveParam(langParam, WALLPAPER_LANG_KEY);
	const locale = resolveLocale(lang);
  
	const fontStyle: CSSProperties = {
		fontFamily: "'SweetSansPro', sans-serif",
		["--mantine-font-family" as string]: "'SweetSansPro', sans-serif",
	};

	return (
		<LocaleProvider locale={locale} dictionary={wallpaperMessages}>
			<WallpaperFlowProvider>
				<div style={fontStyle}>
					<Outlet />
				</div>
			</WallpaperFlowProvider>
		</LocaleProvider>
	);
}
